import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const clipboardPluginKey: PluginKey = new PluginKey('clipboardPlugin');
